// src/components/KpiCard.jsx — carte KPI réutilisable
import React from "react";
import { Paper, Typography, Stack, Box } from "@mui/material";
import { P } from "../theme";

/**
 * KpiCard — affiche une statistique avec icône, label, valeur et sous-texte optionnel.
 *
 * Props :
 *   icon    — élément MUI Icon
 *   label   — libellé (uppercase automatique)
 *   value   — valeur principale (string | number)
 *   sub     — sous-texte optionnel
 *   color   — couleur de l'icône et de l'accent (ex: P.navy)
 *   loading — affiche "…" si true
 */
export default function KpiCard({ icon, label, value, sub, color = P.navy, loading = false }) {
  return (
    <Paper sx={{
      p: 3,
      borderRadius: "12px",
      border: `1px solid ${P.slate[200]}`,
      height: "100%",
    }}>
      <Stack direction="row" spacing={2} alignItems="flex-start">
        {/* Icône */}
        <Box sx={{
          width: 46, height: 46,
          borderRadius: "10px",
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: `${color}18`,
          "& svg": { color, fontSize: 22 },
        }}>
          {icon}
        </Box>

        {/* Textes */}
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{
            fontSize: "0.68rem",
            fontWeight: 700,
            textTransform: "uppercase",
            letterSpacing: "0.08em",
            color: P.slate[500],
            mb: 0.25,
          }}>
            {label}
          </Typography>
          <Typography sx={{
            fontWeight: 800,
            fontSize: "1.6rem",
            lineHeight: 1.1,
            color: P.slate[800],
          }}>
            {loading ? "…" : value}
          </Typography>
          {sub && (
            <Typography sx={{ fontSize: "0.73rem", color: P.slate[400], mt: 0.25 }}>
              {sub}
            </Typography>
          )}
        </Box>
      </Stack>
    </Paper>
  );
}